import React, { Component, Fragment } from 'react';
import { Table, Jumbotron, Row, Col, Button, Form } from 'react-bootstrap';
// ;
import config from '../../config';
import { CSVLink } from "react-csv";

export class ReporteDetalleNomina extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            info: [],
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            currentYear: yyyy,
            periodo: "",
            empresa: currentCompany
        }
    }

    updateReport = () => {
        const { periodo, empresa } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                periodo,
                empresa
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }

        fetch(config.servBackEnd + '/reports/reportdetailnomina', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const info = (data.data || []).sort((a, b) => {
                        const prefijoCompare = (a.TIPO_DOCUMENTO_NOMINA || '').localeCompare(b.TIPO_DOCUMENTO_NOMINA || '');
                        if (prefijoCompare !== 0) return prefijoCompare;
                        const numCompare = (Number(a.NUMERO_DOCUMENTO_NOMINA) || 0) - (Number(b.NUMERO_DOCUMENTO_NOMINA) || 0);
                        if (numCompare !== 0) return numCompare;
                        return (Number(a.ID_DETALLE_NOMINA) || 0) - (Number(b.ID_DETALLE_NOMINA) || 0);
                    });
                    this.setState({ info })
                } else {
                    this.setState({ info: [] })
                }
            })
            .catch((error) => console.error(error))
    }

    render() {
        const { info } = this.state;
        const csvData = info.map(element => {
            const isDevengo = String(element.TIPO) === '1' || element.TIPO === 1;
            const valor = Number(element.VALOR_TOTAL_LINE || element.VALOR || 0);
            const devengo = isDevengo ? valor : 0;
            const deduccion = !isDevengo ? valor : 0;
            const totalDetalle = isDevengo ? valor : -valor;

            return {
                "NIT EMPLEADO": element.DOCUMENTO_CLIENTE,
                "NOMBRE EMPLEADO": element.NOMBRE_CLIENTE,
                "DOCUMENTO": (element.TIPO_DOCUMENTO_NOMINA || '') + "-" + (element.NUMERO_DOCUMENTO_NOMINA || ''),
                "PERIODO INICIO": element.PERIODO_INICIO,
                "PERIODO FIN": element.PERIODO_FIN,
                "DESCRIPCION": element.DESCRIPCION,
                "DEVENGOS": devengo,
                "DEDUCCIONES": deduccion,
                "TOTAL DETALLE": totalDetalle
            };
        });

        return (
            <Fragment>

                <Jumbotron className="Jumbotron">
                    <h2>Reporte Detalle Nómina</h2>
                </Jumbotron>
                <Row>
                    <Col>
                        Fecha Inicial <Form.Control type="date" onChange={(e) => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} />
                    </Col>
                    <Col>
                        Fecha Final <Form.Control type="date" onChange={(e) => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} />
                    </Col>
                    <Col>
                        Periodo
                        <Form.Control
                            as="select"
                            onChange={(e) =>
                                this.setState({ periodo: e.target.value })
                            }
                            value={this.state.periodo}
                            required
                        >
                            <option value="">--Seleccione--</option>
                            <option value={this.state.currentYear + "01"}>Enero</option>
                            <option value={this.state.currentYear + "02"}>Febrero</option>
                            <option value={this.state.currentYear + "03"}>Marzo</option>
                            <option value={this.state.currentYear + "04"}>Abril</option>
                            <option value={this.state.currentYear + "05"}>Mayo</option>
                            <option value={this.state.currentYear + "06"}>Junio</option>
                            <option value={this.state.currentYear + "07"}>Julio</option>
                            <option value={this.state.currentYear + "08"}>Agosto</option>
                            <option value={this.state.currentYear + "09"}>Septiembre</option>
                            <option value={this.state.currentYear + "10"}>Octubre</option>
                            <option value={this.state.currentYear + "11"}>Noviembre</option>
                            <option value={this.state.currentYear + "12"}>Diciembre</option>

                        </Form.Control>
                    </Col>
                    <Col>
                        <Button variant="primary" className="m-3" onClick={this.updateReport} >Generar Informe</Button>
                    </Col>
                    <Col>
                        <CSVLink data={csvData} filename={"REPORTE_DETALLE_NOMINA.csv"} separator={";"}>
                            <Button className="m-3" disabled={info.length === 0} variant="success">Descargar Reporte</Button>
                        </CSVLink>
                    </Col>
                </Row>
                <Table className="tableFixHead">
                    <thead>
                        <tr>
                            <th>NIT EMPLEADO</th>
                            <th>NOMBRE EMPLEADO</th>
                            <th>DOCUMENTO</th>
                            <th>PERIODO INICIO</th>
                            <th>PERIODO FIN</th>
                            <th>DESCRIPCION</th>
                            <th>DEVENGOS</th>
                            <th>DEDUCCIONES</th>
                            <th>TOTAL DETALLE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            info.map((element, index) => {
                                const isDevengo = String(element.TIPO) === '1' || element.TIPO === 1;
                                const valor = Number(element.VALOR_TOTAL_LINE || element.VALOR || 0);
                                const valorFormatted = Intl.NumberFormat('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor);

                                return (
                                    <tr key={index}>
                                        <td>{element.DOCUMENTO_CLIENTE}</td>
                                        <td>{element.NOMBRE_CLIENTE}</td>
                                        <td>{(element.TIPO_DOCUMENTO_NOMINA || '') + "-" + (element.NUMERO_DOCUMENTO_NOMINA || '')}</td>
                                        <td>{element.PERIODO_INICIO}</td>
                                        <td>{element.PERIODO_FIN}</td>
                                        <td>{element.DESCRIPCION}</td>
                                        <td className="currSign">{isDevengo ? valorFormatted : '-'}</td>
                                        <td className="currSign">{!isDevengo ? valorFormatted : '-'}</td>
                                        <td style={{ textAlign: 'right', color: isDevengo ? '#0d6efd' : '#dc3545', fontWeight: '500' }}>
                                            {isDevengo ? `$ ${valorFormatted}` : `-$ ${valorFormatted}`}
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
            </Fragment>
        )
    }
}

export default ReporteDetalleNomina



// WEBPACK FOOTER //
// ./src/components/nomina/ReporteDetalleNomina.jsx